<template>
  <div class="hero-body">
    <p class="title">
      お探しのページが見つかりません。
    </p>
    <p class="subtitle">
      あなたがアクセスしたページは削除されたか
      URLが変更されているため表示することができません。
    </p>
  </div>
</template>

<script>
import appConfig from "../app.config.json";
import {useHead} from "@unhead/vue";

export default {
  name: 'PageNotFound',
  created() {
    useHead({
      title: `ご指定のページが見つかりません | ${appConfig[this.$i18n.locale].title}`,
      meta: [
        {name: 'description', content: appConfig[this.$i18n.locale].description.top},
        {name: 'robots', content: 'noindex,nofollow'}
      ],
    })
  },
}
</script>

<style lang="scss" scoped>

</style>
